import React from 'react';

const AdvancedBackground = ({ children, className = "" }) => {
  return (
    <div className={`min-h-[100dvh] w-full bg-gradient-to-br from-slate-50 via-white to-blue-50 relative overflow-y-auto ${className}`}>
      {/* Advanced Background Elements */}
      <div className="absolute inset-0">
        {/* Animated gradient orbs */}
        <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-br from-crimson/20 to-golden/30 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-gradient-to-tl from-grass/20 to-sky/25 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-gradient-to-r from-golden/15 to-crimson/20 rounded-full blur-2xl animate-pulse delay-500"></div>
        
        {/* Geometric pattern overlay */}
        <div className="absolute inset-0 opacity-[0.02]" style={{
          backgroundImage: `
            linear-gradient(45deg, #DC143C 25%, transparent 25%), 
            linear-gradient(-45deg, #DC143C 25%, transparent 25%), 
            linear-gradient(45deg, transparent 75%, #FFD700 75%), 
            linear-gradient(-45deg, transparent 75%, #FFD700 75%)
          `,
          backgroundSize: '60px 60px',
          backgroundPosition: '0 0, 0 30px, 30px -30px, -30px 0px'
        }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
};

export default AdvancedBackground;